<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Import indstillinger</mat-panel-title>
  </mat-expansion-panel-header>
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Vis muligheden for at importere statusnoter?</dt>
        <dd>{{value.show_import_project_statuses ? 'Ja' : 'Nej'}}</dd>
      </dl>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" class="mb-3">
        <div fxFlex="45" fxLayout="column">
          <mat-checkbox ngDefaultControl formControlName="show_import_project_statuses">Vis muligheden for at importere statusnoter?</mat-checkbox>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
